import axios from "axios";

import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";
import CreateGetRequiredEpirbAction from "./CreateGetRequiredEpirbAction";
import RefreshLicenceIsvalidAction from "./RefreshLicenceIsvalidAction";

export default function deleteEpirb(id) {
    return async (dispatch, getState) => {
        dispatch(CreateDataRetrievalBegunAction());

        const { currentApplication } = getState();

        const licenceApplicationId = currentApplication.id ?? 0;
        const licenceStatusId = currentApplication.licenceApplicationStatusTypeId ?? 0;

        try {
            await axios.delete(`api/EpirbDetail?id=${id}`, {
                withCredentials: true
            });

            dispatch(
                CreateGetRequiredEpirbAction(licenceApplicationId)
            );

            if (licenceStatusId > 1) {
                dispatch(
                    RefreshLicenceIsvalidAction(licenceApplicationId)
                );
            }
        } catch (error) {
            console.error("Failed to delete EPIRB", error);

            dispatch(CreateDataRetrievalEndedAction());
        }
    };
}